<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-button size='small' @click="()=>{ $router.push({path:'/wxPublic/wxManagement/drewManagement',query:{active:2}})}">
        <LeftOutlined />返回 </a-button>
      <span class="ml15 fz-20">{{$route.query.type == 'add' ? '添加':'修改'}}高级图文</span>
    </a-card>
    <a-card :bordered='false'>
      <div class="s_flex_bian s_bor_cbed">
        <div class="width25">
          <p class="height-40 s_bf58 s_ptb0lr24 s_flex_ali s_font_b">图文列表</p>
          <transition-group appear tag="div">
            <div class="p-6 img_list" :class='listIndex == index ? "img_list_bor":""' v-for="(item,index) in imgTextList" :key="index" draggable="true"
              @dragstart="dragstart(item)" @dragenter="dragenter(item)" @dragend="dragend(item)" @click='selectList(index)'>
              <div class="s_po_re">
                <div v-if='item.file_url'>
                  <img v-if='item.file_url.indexOf(info.picdomain) == -1' class="img" :src="info.picdomain+'/'+item.file_url" alt="">
                  <img v-else  class="img" :src="item.file_url" alt="">
                </div>
                <div class="img s_flex_center" v-else>
                  <div>
                    <PictureOutlined class="fz-40 s_c999" />
                    <p class="s_c999 text-ac">未上传</p>
                  </div>
                </div>
                <div class="s_po_ab_bl width100 height-35 p-l-15 p-r-15 s_flex_bian_c"
                  style="background-color: rgba(0, 0, 0, .4);">
                  <p class="width80 s_omit s_cfff">{{item.title || '标题'}}</p>
                  <DeleteFilled class="s_cfff fz-18" @click='editList("del",index)' />
                </div>
              </div>
            </div>
          </transition-group>
          <div class="img_list" @click='editList("add",0)' v-if='imgTextList.length < 8'>
            <div class="img s_flex_center">
              <PlusOutlined class="fz-40 s_c999" />
            </div>
          </div>
        </div>
        <div class="width75 s_bl1 p-t-40 p-b-25">
          <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-item ref="title" label="标题" name="title">
              <a-input v-model:value="form.title" placeholder='请输入标题' @keyup='()=>{imgTextList[listIndex].title = form.title}' />
            </a-form-item>
            <a-form-item ref="http_url" label="链接" name="http_url" help='设置后，点击手机端图文消息，直接进入所设链接地址。'>
              <p v-if='form.http_url == ""'>请设置链接地址 <a-button type="link" @click="()=>{visible = true;customUrl=''}">设置</a-button>
              </p>
              <p v-else>{{form.http_url}} <a-button type="link" @click="()=>{visible = true;customUrl=form.http_url}">修改</a-button>
              </p>
            </a-form-item>
            <a-form-item ref="file_url" label="封面" name="file_url" help='建议尺寸：360像素 * 200像素' :rules="[{ required: true, message: '请选择图片' }]">
              <wxMaterial :groupType='1' :image="form.file_url" :max="1"
              v-on:handlechoose="(data)=>{form.file_url=data.imageUrl;form.media_id=data.data.media_id;imgTextList[listIndex].file_url = data.imageUrl;imgTextList[listIndex].media_id = data.data.media_id}" v-on:handledel="form.media_id='';form.file_url=''" />
            </a-form-item>
             <a-form-item ref="" label="media_id" name="" hidden>
              <a-input v-model:value="form.media_id"  />
            </a-form-item>
            <a-form-item ref="" label="摘要" name="">
              <a-textarea v-model:value="form.digest" showCount :maxlength="120" :rows="4"
                placeholder='选填，该描述只在发送图文消息为单条时显示' @change='()=>{imgTextList[listIndex].digest = form.digest}' />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
              <a-button style="width:100px" type="primary" @click="onSubmit">
                保存
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择链接" :width='800' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <a-tabs type="card" >
      <!-- <a-tab-pane key="1" tab="功能链接">
        <div class="s_ptb0lr24">
          <div class="s_flex_bian_c m-b-15" v-for='item in linkList' :key='item'>
            <p class="s_c333">店铺首页</p>
            <a-button type="primary" ghost>选择</a-button>
          </div>
        </div>
      </a-tab-pane> -->
      <a-tab-pane key="2" tab="自定义链接">
        <div class="s_flex_bian_c">
          <p>请输入链接地址：</p>
          <a-input class="width73" v-model:value="customUrl" placeholder='请输入链接地址，例：https://www.baidu.com' />
          <a-button type="primary" @click='()=>{form.http_url = customUrl,visible= false,imgTextList[listIndex].http_url=customUrl}'>确定</a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
  import { DeleteFilled, PlusOutlined,PictureOutlined ,LeftOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, onUpdated } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import {getWxGraphicSeniorMore,wxGraphicSeniorAdd,wxGraphicSeniorEdit} from '@/api/public_wx'
  import store from "@/store";
  let defForm = {
    title: '',
    file_url: '',
    digest: '',
    media_id:'',
    http_url:''
  }
  export default {
    components: { DeleteFilled, PlusOutlined,PictureOutlined,LeftOutlined },
    setup(props) {
      const form = ref({ ...defForm });
      const state = reactive({
        info: store.state.user.info,
        visible: false,
        customUrl:'',
        imgTextList: [{ title: '', file_url: '',media_id:'',digest:'',http_url:'' }],
        listIndex:0,
        // linkList: [{}, {}, {}],
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        oldNum: 0,
        newNum: 0,
        rules: {
          title: [
            { required: true, message: '请输入标题'},
          ],
          http_url: [
            { required: true, message: '请请设置链接'},
          ],
          file_url: [
            { required: true, message: '请选择封面'},
          ],
        }
      });
      
      const ruleForm = ref()
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      const editList = (type, index) => {
        if (type == 'add') {
          state.imgTextList.push({ title: '', file_url: '',media_id:'',digest:'',http_url:''})
          console.log(state.listIndex)
          console.log(state.imgTextList)
        } else {
          if (state.imgTextList.length == 1) {
            $Modal.warning({
              title: '请至少保留一个图文',
              centered: true
            });
            return false
          }
          if(index==state.listIndex){
              state.listIndex = 0
          }else{
             state.listIndex=state.imgTextList.length-2
          }
          selectList(state.listIndex)
          state.imgTextList.splice(index, 1)
          state.listIndex = state.imgTextList.length - 1
          console.log(state.listIndex)
          console.log(state.imgTextList)
        }
      }
      var selectList = (e) =>{
        state.listIndex = e
        form.value = state.imgTextList[e]
      }
      // 记录初始信息
      const dragstart = (value) => {
        state.oldNum = value;
      }
      // 做最终操作
      const dragend = (value) => {
        if (state.oldNum != state.newNum) {
          let oldIndex = state.imgTextList.indexOf(state.oldNum);
          let newIndex = state.imgTextList.indexOf(state.newNum);
          let newItems = [...state.imgTextList];
          // 删除老的节点
          newItems.splice(oldIndex, 1);
          // 在列表中目标位置增加新的节点
          newItems.splice(newIndex, 0, state.oldNum);
          // this.items一改变，transition-group就起了作用
          state.imgTextList = [...newItems];
        }
      }
      // 记录移动过程中信息
      const dragenter = (value) => {
        state.newNum = value;
      }
      const getMore = async(id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getWxGraphicSeniorMore({id:id}).then(res => res.data);
        if (iscode(res)) {
          state.imgTextList = res.data.list
          form.value = res.data.list[0]
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if ($route.query.type == 'add') {
            res = await wxGraphicSeniorAdd({list_json:JSON.stringify(state.imgTextList)}).then(res => res.data);
          } else {
            res = await wxGraphicSeniorEdit({id:$route.query.id,list_json:JSON.stringify(state.imgTextList)}).then(res => res.data);
          }
          if (iscode(res,true)) {
             $router.push({path:'/wxPublic/wxManagement/drewManagement',query:{active:2}});
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        if ($route.query.type == 'edit') {
          getMore($route.query.id);
        }
      });
      return {
        ...toRefs(state),
        form,
        editList,
        dragstart,
        dragend,
        dragenter,
        ruleForm,
        onSubmit,
        selectList
      };
    },
  };
</script>
<style lang="less" scoped>

  .img_list .img {
    width: 100%;
    height: 200px;
  }

  .img_list {
    border: 1px solid #fff;
    border-bottom: 1px solid #83c8dd;
    cursor: pointer
  }

  .img_list:hover {
    border: 1px dashed #05486A;
  }
  .img_list_bor{border: 1px dashed #05486A;}
</style>